module.exports = __webpack_public_path__ + "img/img29.970e21e7.svg";